import styled from 'styled-components'

import { Flexbox } from './Flexbox'

const BASE_SIZE = '22px'

const Key = styled.span`
  ${({ theme }) => theme.font.label02}
  font-size: 0.75rem;
  min-width: ${BASE_SIZE};
  height: ${BASE_SIZE};
  line-height: ${BASE_SIZE};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  padding: 0.25rem;
  border: 1px solid ${({ theme }) => theme.colour.secondary._100};
  background-color: ${({ theme }) => theme.colour.neutral.white};
  color: ${({ theme }) => theme.colour.secondary._500};
`

type Props = {
  keys: string[]
}

export const ShortcutText: React.FC<Props> = ({ keys }) => {
  return (
    <Flexbox flex="inline-flex" alignItems="center" gap="0.25rem">
      {keys.map((key, index) => (
        <Key key={key + index}>{key}</Key>
      ))}
    </Flexbox>
  )
}
